import e2e from './e2e';

export default {
  e2e,
};
